import React, { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// Load layout components
import PageSpinner from '../components/layout/PageSpinner';
import OffersComponent from '../components/offers/OffersComponent';

import { GlobalContext } from '../store/Provider';

const Offers = () => {
  const { t } = useTranslation();
  const { offersState } = useContext(GlobalContext);

  return (
    <Fragment>
      {offersState.offers.fetching ? (
        <PageSpinner msg={t('general.stillFetchingData')} />
      ) : (
        <OffersComponent />
      )}
    </Fragment>
  );
};

export default Offers;
